/*
 * Copyright 2022, Corning Optical Communications
 * All Rights Reserved.
 */

import React from 'react'
import './Status.css'
import { formatNumber } from '../../../utils/helpers';
import StatusIcon from './StatusIcon';

const CellKpiStatus: React.FC<{ status: string, value: Number }> = ({ status, value }) => {
  return (
    <span style={{ alignItems: "center", display: "flex" }}>
        <StatusIcon status={status} isLabel={false} />
        &nbsp;&nbsp;<span>{`${formatNumber(value || 0).toString()} %`}</span>
      </span>
  )
};

export default CellKpiStatus;
